<template>
  <div class="content">
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">
            {{ $t("wms.menu.inventory_history") }}
          </h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">

              <div class="form-group row">
                <div class="col-md-3">
                  <base-input>
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true, enableTime: true,dateFormat: 'Y-m-d H:i',time_24hr: true }"
                      class="form-control datepicker"
                      v-model="startDate"
                    >
                    </flat-picker>
                  </base-input>
                </div>

                <div class="col-md-3">
                  <base-input>
                    <flat-picker
                      slot-scope="{ focus, blur }"
                      @on-open="focus"
                      @on-close="blur"
                      :config="{ allowInput: true ,enableTime: true,dateFormat: 'Y-m-d H:i',time_24hr: true }"
                      class="form-control datepicker"
                      v-model="endDate"
                    >
                    </flat-picker>
                  </base-input>
                </div>

                <div>
                  <base-input v-model="SearchKeyword" placeholder="หมายเลขบิล">
                  </base-input>
                </div>

                <div class="col-md-1">
                  <base-button size="md" type="neutral" @click="SearchData()">
                    Search
                  </base-button>
                </div>
              </div>
            </div>
          </template>
          <div>
            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                v-bind="column"
              >
              </el-table-column>

              <el-table-column
                min-width="200px"
                align="right"
                :label="$t('actions')"
              >
                <div slot-scope="{ $index, row }" class="d-flex">
                  <base-button
                    @click.native="handleDetail($index, row)"
                    class="edit"
                    type="warning"
                    size="sm"
                    icon
                  >
                    <i class="text-dtac-bt fa fa-edit"></i>
                    Detail
                  </base-button>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class=" col-12 d-flex justify-content-center justify-content-sm-between flex-wrap "
			v-if="tableData.length != 0"
          >
            <div class="">
              <p class="card-category">
                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }} {{ to }}
                {{ $t("of") }}
                {{ total }}
                <span v-if="selectedRows.length">
                  - &nbsp; &nbsp; {{ selectedRows.length }}
                  {{ $t("row_select") }}
                </span>
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </div>

    <modal :show.sync="showAddModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          :label="$t('wms.product')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.ProductID" :placeholder="$t('wms.product')">
            <el-option
              v-for="option in Product"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          :label="$t('wms.storage')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.StorageID" :placeholder="$t('wms.storage')">
            <el-option
              v-for="option in Storage"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>

        <base-input
          v-model="md.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="md.Cost"
          :label="$t('wms.cost')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="md.Note"
          :label="$t('wms.note')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

    <modal :show.sync="showInOutModal" modal-classes="modal-secondary">
      <form class="new-event--form" @submit.prevent="saveEvent">
        <base-input
          v-model="inOut.Quantity"
          :label="$t('wms.amount')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="inOut.Cost"
          :label="$t('wms.cost')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <base-input
          v-model="inOut.Note"
          :label="$t('wms.note')"
          input-classes="form-control-alternative new-event--title"
        >
        </base-input>

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdateInOut()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showInOutModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/clientPaginationMixin";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'

export default {
  mixins: [clientPaginationMixin],
  components: {
    flatPicker,
    BasePagination,
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "WmsInventory/getHistory",
    }),
    tableData: function () {
      // if (this.SearchKeyword != "") {
      //   return this.tableDataOrg.filter((d) => {});
      // } else {
      //   return this.tableDataOrg;
      // }
      return this.tableDataOrg;
    },
    tableColumns: function () {
      return [
        {
          prop: "CreateAt",
          label: this.$t("wms.created_at"),
          minWidth: 90,
          sortable: true,
        },
        {
          prop: "BillNumber",
          label: this.$t("wms.bill_number"),
          minWidth: 100,
          sortable: true,
        },
        {
          prop: "UserName",
          label: this.$t("wms.staff"),
          minWidth: 100,
          sortable: true,
        },
        {
          prop: "Note",
          label: this.$t("wms.note"),
          minWidth: 120,
          sortable: true,
        },
      ];
    },
  },
  data() {
    return {
      propsToSearch: ["Number", "Email"],
      selectedRows: [],
      SearchKeyword: "",
      showAddModal: false,
      showInOutModal: false,
      StorageID: 0,
      startDate: "",
      endDate: "",
      md: {
        InventoryID: 0,
        ProductID: "-",
        StorageID: "-",
        Note: "",
        Quantity: "0",
        Cost: 0,
      },
      inOut: {
        InventoryID: 0,
        ProductID: 0,
        StorageID: 0,
        Note: "",
        Quantity: 0,
        Cost: 0,
        Action: "",
      },
      rowEdit: {
        ID: 0,
        Number: "",
      },
    };
  },
  mounted() {
	var today = moment().format('YYYY-MM-DD');
	this.startDate = today;
	this.endDate = moment(today).add(23,'hours').add(59,'minutes').format('YYYY-MM-DD HH:mm');


    this.SearchData();
  },
  methods: {
    ...mapActions({
      listHistory: "WmsInventory/listHistory",
    }),
    SearchData() {
      let params = {
        StartDate: this.startDate,
        EndDate: this.endDate,
        BillNumber: this.SearchKeyword,
      };
      this.listHistory(params);
    },

    handleDetail(index, row) {
      // this.$router.push("/wms/historydetail/" + row.ID);
      window.open("/wms/historydetail/" + row.ID);
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
  },
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
